import type { LaunchReadinessStatus } from "@/features/tools/proToolTypes";

export const launchReadinessStatuses: Array<{
  value: LaunchReadinessStatus;
  label: string;
  description: string;
}> = [
  {
    value: "not_started",
    label: "Not started",
    description: "This part has not been built yet.",
  },
  {
    value: "partly_working",
    label: "Partly working",
    description: "Some of it exists, but it needs more work.",
  },
  {
    value: "working",
    label: "Working",
    description: "It works in the app, but has not been fully tested.",
  },
  {
    value: "tested",
    label: "Tested",
    description: "It works and has been checked with realistic inputs.",
  },
];
